// for our iframe and gateway wrapper to work, these should not end with /
export const routerBasePath = process.env.NODE_ENV === "production" ? "/spa/wrapper" : "";

export const serviceError = "service-error";

export const userRoute = 'user';
